"use strict"
const Readable = require('stream').Readable
const inherits = require('util').inherits

function DispatchOutputStream (options) {
  if (!(this instanceof DispatchOutputStream)) {
    return new DispatchOutputStream(options)
  }
  Readable.call(this, {objectMode: true})
  this.dispatchReadState = options.readState
  this.dispatchWriteState = options.writeState
  this.name = options.name
  this.read(0)
}

inherits(DispatchOutputStream, Readable)

DispatchOutputStream.prototype._read = function () {
  const readState = this.dispatchReadState
  const writeState = this.dispatchWriteState
  if (readState.waitingForOutput === this && writeState.pendingcb) {
    this.push(readState.pendingData)
    readState.waitingForOutput = null
    readState.pendingData = null
    writeState.onwrite()
  }
}

module.exports = DispatchOutputStream
